import StoreHelper from '../../../store/helper'
import EventBuilder from '../EventBuilder'

import _ from 'lodash'

export const onTouchmove = (e) => {
  const dropTarget = _getDropTargetFromPoints(e)

  if (!!StoreHelper.getTouchDropTarget() && !StoreHelper.isTouchDropTarget(dropTarget)) {
    StoreHelper.getTouchDropTarget().dispatchEvent(EventBuilder.createDragleaveEvent())
  }

  StoreHelper.setTouchDropTarget(dropTarget)
  dropTarget.dispatchEvent(EventBuilder.createDragoverEvent())
}

const _getDropTargetFromPoints = (e) => {
  const points = {
    x: _.get(_.head(e.changedTouches), 'clientX', 0),
    y: _.get(_.head(e.changedTouches), 'clientY', 0)
  }

  return document.elementFromPoint(points.x, points.y)
}
